<template>
    <div>
      <Navbar></Navbar>
      <Header></Header>
      <Principal></Principal>
      <Cards></Cards>
  
      <Cover></Cover>
      <Logos></Logos>
      <Footer></Footer>
    </div>
  </template>
  
  <script>
  
  import Navbar from '../components/Navbar.vue';
  import Header from '../components/Header.vue';
  import Principal from '../components/Principal.vue';
  import Cards from '../components/Cards.vue';
  
  import Cover from '../components/Cover.vue';
  import Logos from '../components/Logos.vue';
  import Footer from '../components/Footer.vue';
  export default {
    name: "App",
    components: {
      Navbar,
      Header,
      Principal,
      Cards,
  
      Cover,
      Logos,
      Footer
    },
  };
  </script>
  
  <style>
  *{
    font-family: "Outfit", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-variation-settings:
      "wdth" 100;
  }
  body{
    margin: 0;
    padding: 0;
  }
  </style>
  